module.exports = __webpack_public_path__ + "static/108-2762d41acd74c98f4d08581e357fc931.png";